<!-- order-details.component.html -->
<div class="page OrDetails">
  <a backButton class="OrDetails__BackLink">
    <i class="fas fa-chevron-left"></i>
    {{ 'common.back' | translate }}
  </a>
</div>

<div class="container mx-auto p-4 max-w-3xl">

  <div class="card p-6">
    <div style="display: flex; justify-content: center; align-items: center;">
      <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
        <div style="width: 35%; background-color: #d1fae5; padding: 1.5rem; border-radius: 0.75rem; margin-bottom: 1rem;">
          <img style="width: 100%;" [src]="orderDetails.storeUser?.storeLogoUrl" alt="LOGO">
        </div>
        <div>
          <div [style.background-color]= "orderStatusColor[orderDetails.status]" style="color:  white;"> {{orderDetails.status}}</div>
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 500;">{{ orderDetails.orderNumber }}</h2>
          <div class="status-container">
            <div class="status-actions">
              <button
                class="status-button"
                [ngClass]="{'active': status === orderDetails.status}"
                [style]="{'background-color':orderStatusColor[status], 'color':'white'}"
                *ngFor="let status of getAllowedStatusButtons(orderDetails.status)"
                (click)="updateStatus(status)">
                {{ getStatusLabel(status) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid gap-4">
      <div class="grid gap-2">
        <div>
          <p class="text-sm text-muted-foreground">{{ 'store.orders.table.purchasedBy' | translate }}:</p>
          <p class="font-medium">{{ orderDetails.user.firstName }} {{ orderDetails.user.lastName }}</p>
        </div>
        <div>
          <p class="text-sm text-muted-foreground">{{ 'store.ecommerceOrders.details.phone' | translate }}:</p>
          <p class="font-medium">{{ orderDetails.user.phoneNumber }}</p>
        </div>
        <div>
          <p class="text-sm text-muted-foreground">{{ 'store.products.table.createdDate' | translate }}:</p>
          <p  class="font-medium"><span class="ltr-text">{{ orderDetails.createdDate | date: 'hh:mm, d MMMM y' }}</span></p>
        </div>
      </div>

      <div class="border-t border-b py-4">
        <h3 class="font-medium mb-3">{{ 'store.ecommerceOrders.details.items' | translate }}</h3>
        <div>
          <div
            *ngFor="let item of items.data"
            class="flex justify-between"
          >
            <div>
              <p class="font-medium">{{ item.name }}</p>
              <p class="text-sm text-muted-foreground">{{ 'store.ecommerceOrders.details.quantity' | translate }}: {{ item.quantity }}</p>
            </div>
            <p class="font-medium">
              {{ orderDetails.currency.symbol }}{{ item.price * item.quantity }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <p class="text-sm text-muted-foreground">{{ 'store.orders.details.totalAmount' | translate }}:</p>
        <p class="font-medium">ILS{{ orderDetails.totalAmount }}</p>
      </div>

    </div>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
